<script setup>
import {defineProps, ref} from 'vue';

const {
  service,
  currency,
  rates
} = defineProps(['service', 'currency', 'rates']);

</script>

<style>
#projectTable tr th, #projectTable tr td {
  padding: .5rem;
}
</style>

<template>
  <AppLayout>
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 layout-spacing">
      <div class="widget widget-six">


        <div class="widget-heading pb-0 d-block">
          <div class="row">
            <div class="col-md-12 col-lg-10 d-flex align-items-center justify-content-between flex-wrap">
              <div>
                <h4 class="d-inline-block h4 me-4" style="line-height: 1.4">
                  Zgłoszenie: <b>{{ service.number }}</b>
                </h4>
                <span class="text-danger font-weight-bolder" v-if="service.archived">ZARCHIWIZOWANE</span>
              </div>
              <div class="ms-4">
                <Link :href="route('service.index')" class="btn btn-outline-primary">
                  <i class="bi bi-list"></i>&nbsp;Lista zgłoszeń
                </Link>
              </div>
            </div>
            <div class="col-md-12 col-lg-2 text-end">
              <form id="deleteServiceForm" class="d-inline-block me-2" method="post" @submit.prevent="deleteService">
                <input type="hidden" name="_token" :value="csrfToken">
                <button v-if="hasPermission('canDelService')" class="btn btn-outline-danger">Usuń zgłoszenie</button>
              </form>
            </div>
          </div>


          <div class="row">
            <div v-if="hasPermission('canEditService')" class="col-6 my-2">
              <form @submit.prevent="submitHideOnList" class="mt-3">
                <div class="checkbox-success custom-control custom-checkbox d-inline-block">
                  <input id="serviceHideOnList" type="checkbox" class="custom-control-input"
                         :checked="service.hide_on_list" @change="changeServiceHideOnList">
                  <label for="serviceHideOnList" class="custom-control-label h6">Nie pokazuj na liście zgłoszeń</label>
                </div>
                <button v-if="hideOnListServiceHasChanged" type="submit" class="btn btn-primary btn-sm ms-2">Zapisz
                </button>
              </form>
            </div>
            <div v-if="hasPermission('canEditService')" class="col-6 my-2">
              <form @submit.prevent="submitArchived" class="mt-3">
                <div class="checkbox-success custom-control custom-checkbox d-inline-block">
                  <input id="servicearchived" type="checkbox" class="custom-control-input"
                         :checked="service.archived" @change="changeServiceArchived">
                  <label for="servicearchived" class="custom-control-label h6">Archiwizuj zgłoszenie</label>
                </div>
                <button v-if="archivedHasChanged" type="submit" class="btn btn-primary btn-sm ms-2">Zapisz
                </button>
              </form>
            </div>
          </div>
          <serviceMenu :service="service"></serviceMenu>

        </div>


        <div class="widget-content">
          <div v-if="$page.props.errors">
            <ul style="list-style-type: none; padding: 0" v-for="error in $page.props.errors">
              <li class="alert alert-danger">{{ error }}</li>
            </ul>
          </div>
          <div class="row mt-3">
            <div class="col-md-12 col-lg-12">
              <div class="row">

                <h5>Dodaj koszta:</h5>
                <div class="row">
                  <div class="table-responsive">

                    <div class="row">
                      <div class="col-md-6 col-lg-3 mb-3">
                        <label class="form-label" for="currency">Waluta wprowadanych kosztów:</label>
                        <select class="form-select form-select-sm border-1" id="currency" v-model="selectedCurrency"
                                @change="updateCurrency">
                          <option value="PLN">PLN</option>
                          <option value="EUR">EUR</option>
                        </select>
                      </div>
                    </div>

                    <form @submit.prevent="saveServiceCost">

                      <div class="row">
                        <div class="col-md-6 col-lg-3 mb-3">
                          <label class="form-label" for="rateid">Rodzaj stawki (szablon):</label>
                          <select class="form-select form-select-sm border-1" v-model="selectedRateId">
                            <option v-for="rate in rates" :value="rate.id" :key="rate.id">
                              {{ rate.name }}
                            </option>
                          </select>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6 col-lg-3 mb-3">
                          <label class="form-label" for="rate_name">Nazwa kosztów:</label>
                          <input type="text" name="rate_name" class="form-control form-control-sm border-1"
                                 v-model="selectedRateName"/>
                        </div>

                        <div class="col-md-6 col-lg-3 mb-3">
                          <label class="form-label" for="price_company">Koszta firmy:</label>
                          <input type="text" name="price_company" class="form-control form-control-sm border-1"
                                 v-model="selectedPriceCompany">
                        </div>

                        <div class="col-md-6 col-lg-3 mb-3">
                          <label class="form-label" for="price_client">Koszta klienta:</label>
                          <input type="text" name="price_client" class="form-control form-control-sm border-1"
                                 v-model="selectedPriceClient">
                        </div>

                        <div class="col-md-6 col-lg-3 mb-3">
                          <label class="form-label" for="quantity">Ilość:</label>
                          <input type="number" class="form-control form-control-sm border-1" v-model.number="quantity"
                                 step="any"
                                 :class="{'bg-danger text-dark': quantity === null || quantity === undefined || quantity === ''}"
                                 @input="sanitizeQuantity">
                        </div>
                      </div>

                      <table id="projectTable" class="table table-bordered p-2">
                        <tr v-if="quantity && selectedRateName">
                          <th colspan="4" class="text-end">Łączna cena dla firmy:</th>
                          <td colspan="4" class="fw-bold text-primary">{{ totalCompanyPrice }}</td>
                        </tr>
                        <tr v-if="quantity && selectedRateName">
                          <th colspan="4" class="text-end">Łączna cena dla klienta:</th>
                          <td colspan="4" class="fw-bold text-success">{{ totalClientPrice }}</td>
                        </tr>
                        <tr v-if="quantity && selectedRateName">
                          <th colspan="4" class="text-end"></th>
                          <td colspan="4" class="fw-bold text-success">
                            <button type="submit" class="btn btn-primary">Dodaj koszta</button>
                          </td>
                        </tr>
                      </table>
                    </form>
                  </div>

                  <div class="table-responsive mt-4">
                    <div class="d-flex justify-content-between align-items-center mb-2">
                      <h5 class="mb-0">Lista kosztów</h5>
                      <div class="d-flex gap-2">
                        <a :href="route('service.generatePdf', { id: service.id })" class="btn btn-outline-info btn-sm">
                          <i class="bi bi-file-earmark-pdf"></i> Pobierz zestawienie
                        </a>
                        <a :href="route('service.viewPdf', { id: service.id })" rel="noopener noreferrer"
                           target="_blank" class="btn btn-outline-info btn-sm">
                          <i class="bi bi-eye"></i> Podgląd zestawienia
                        </a>
                        <button @click="exportExcel" class="btn btn-outline-success btn-sm">
                          <i class="bi bi-file-earmark-excel"></i> Eksport do Excela
                        </button>
                      </div>
                    </div>

                    <ejs-grid ref="grid" :dataSource="augmentedServiceCosts" :allowExcelExport="true" :toolbar="toolbar"
                              style="display:none;">
                      <e-columns>
                        <e-column field="rate_name" headerText="Rodzaj stawki" width="150"></e-column>
                        <e-column field="n_price_company" type="number" format="N2" headerText="Koszta firmy"
                                  width="100"></e-column>
                        <e-column field="n_price_client" type="number" format="N2" headerText="Koszta klienta"
                                  width="100"></e-column>
                        <e-column field="total_quantity" type="number" headerText="Ilość" width="100"></e-column>
                        <e-column field="total_company" type="number" format="N2" headerText="Razem firma"
                                  width="120"></e-column>
                        <e-column field="total_client" type="number" format="N2" headerText="Razem klient"
                                  width="120"></e-column>
                      </e-columns>
                    </ejs-grid>


                    <table class="table table-bordered">
                      <thead>
                      <tr>
                        <th>#</th>
                        <th>Rodzaj stawki</th>
                        <th>Koszta firmy</th>
                        <th>Koszta klienta</th>
                        <th>Ilość</th>
                        <th>Razem firma</th>
                        <th>Razem klient</th>
                        <th>Akcje</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(cost, index) in serviceCosts" :key="cost.id">
                        <td>{{ index + 1 }}</td>
                        <td>
                          <input v-if="editingId === cost.id" v-model="cost.rate_name"
                                 class="form-control form-control-sm"/>
                          <span v-else>{{ cost.rate_name }}</span>
                        </td>
                        <td>
                          <input v-if="editingId === cost.id" v-model="cost.price_company"
                                 class="form-control form-control-sm"/>
                          <span v-else>{{ cost.price_company }}</span>
                        </td>
                        <td>
                          <input v-if="editingId === cost.id" v-model="cost.price_client"
                                 class="form-control form-control-sm"/>
                          <span v-else>{{ cost.price_client }}</span>
                        </td>
                        <td>
                          <input v-if="editingId === cost.id" v-model="cost.quantity" type="number" step="any"
                                 class="form-control form-control-sm"/>
                          <span v-else>{{ Math.round(cost.quantity) }}</span>
                        </td>
                        <td>{{ (cost.price_company * cost.quantity).toFixed(2) }}</td>
                        <td>{{ (cost.price_client * cost.quantity).toFixed(2) }}</td>
                        <td>
                          <button v-if="editingId === cost.id" @click="updateServiceCost(cost)"
                                  class="btn btn-sm btn-success me-2">Zapisz
                          </button>
                          <button v-else @click="editServiceCost(cost.id)" class="btn btn-sm btn-outline-info  me-2"><i
                              class="bi bi-pencil me-2"></i>Edytuj
                          </button>
                          <button class="btn btn-danger btn-sm" @click="deleteServiceCost(cost.id)"><i
                              class="bi bi-trash me-2"></i>Usuń
                          </button>
                        </td>
                      </tr>
                      </tbody>
                      <tfoot>
                      <tr>
                        <th colspan="5" class="text-end">Łączna suma:</th>
                        <th>{{ totalSumf.toFixed(2) }} {{ selectedCurrency }}</th>
                        <th>{{ totalSumc.toFixed(2) }} {{ selectedCurrency }}</th>
                        <th></th>
                      </tr>
                      </tfoot>
                    </table>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>


      </div>
    </div>
  </AppLayout>
</template>

<script>
import AppLayout from "@/Layouts/App.vue";
import {defineProps, ref} from "vue";
import {useForm} from "@inertiajs/vue3";

import route from "../../../../vendor/tightenco/ziggy/src/js/index.js";
import {router} from "@inertiajs/vue3";
import {Tooltip} from 'bootstrap';
import {isDisabled} from "bootstrap/js/src/util/index.js";
import {usePermission} from "@/composables/resources/js/composables/permissions.js";
import {GridComponent, ColumnsDirective, ColumnDirective, Toolbar, ExcelExport} from '@syncfusion/ej2-vue-grids';
import serviceMenu from "@/Pages/Service/serviceMenu.vue";

const {hasPermission} = usePermission();

export default {
  components: {
    AppLayout,
    'ejs-grid': GridComponent,
    'e-columns': ColumnsDirective,
    'e-column': ColumnDirective, serviceMenu
  },


  props: {
    service: {
      type: Object,
      required: true,
      default: () => ({})
    },
    rates: {
      type: Object,
      required: true,
      default: () => ({})
    },
    currency: {
      type: Object,
      required: true,
      default: () => ({})
    },
  }
  ,
  data() {
    return {
      toolbar: ['ExcelExport'],

      selectedCurrency: this.currency.currency || "PLN",
      selectedRateId: null,
      selectedRateName: "",
      selectedPriceCompany: 0,
      selectedPriceClient: 0,
      editingId: null,
      quantity: 1,
      serviceCosts: [],
      hideOnListForm: useForm({
        hide_on_list: this.service.hide_on_list || false
      }),
      hideOnListServiceHasChanged: false,
      archiveOnListForm: useForm({
        archived: this.service.archived || false
      }),
      archivedHasChanged: false,
      isLoading: false,
      hasPermission,
      form: {
        name: null,
        attachments: [],
        errors: {},
        currency: this.currency.currency || "PLN"
      },
    };
  },
  computed: {
    selectedRate() {
      return this.rates.find(rate => rate.id === this.selectedRateId) || {
        rate_name: "",
        price_company: 0,
        price_client: 0
      };
    },

    augmentedServiceCosts() {
      return this.serviceCosts.map(cost => ({
        ...cost,
        total_company: parseFloat((parseFloat(cost.price_company) * parseFloat(cost.quantity)).toFixed(2)),
        total_client: parseFloat((parseFloat(cost.price_client) * parseFloat(cost.quantity)).toFixed(2)),
        total_quantity: parseFloat((parseFloat(cost.quantity)).toFixed(0)),
        n_price_company: parseFloat((parseFloat(cost.price_company)).toFixed(2)),
        n_price_client: parseFloat((parseFloat(cost.price_client)).toFixed(2))
      }));
    },


    totalCompanyPrice() {
      return (this.selectedPriceCompany * this.quantity).toLocaleString("pl-PL", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    },
    totalClientPrice() {
      return (this.selectedPriceClient * this.quantity).toLocaleString("pl-PL", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    },
    totalSumc() {
      return this.serviceCosts.reduce((sum, cost) => sum + (cost.price_client * cost.quantity), 0);
    },
    totalSumf() {
      return this.serviceCosts.reduce((sum, cost) => sum + (cost.price_company * cost.quantity), 0);
    }
  },
  watch: {
    selectedRateId(newId) {
      const rate = this.rates.find(r => r.id === newId);
      this.selectedRateName = rate ? rate.name : "";
      this.selectedPriceCompany = rate ? rate.price_company : "";
      this.selectedPriceClient = rate ? rate.price_client : "";
    }
  },
  mounted() {
    this.fetchServiceCosts(this.service.id);
  },

  methods: {
    route,
    exportExcel(args) {
      let fileName = "Zestawienie_serwis_" + this.service.number + ".xlsx";
      let sheetName = "Arkusz1"; 
      if (args.workbook && args.workbook.sheets.length > 0) {
        args.workbook.sheets[0].name = sheetName;
      }
      this.$refs.grid.excelExport({
        fileName: fileName,
        workbook: args.workbook
      });
    },

    isRouteActive(routeName) {
      return route().current() === routeName;
    },


    changeServiceHideOnList() {
      this.hideOnListForm.hide_on_list = event.target.checked;
      this.hideOnListServiceHasChanged = true;
    },

    changeServiceArchived() {
      this.archiveOnListForm.archived = event.target.checked;
      this.archivedHasChanged = true;
    },

    editServiceCost(costId) {
      this.editingId = costId;
    },
    updateServiceCost(cost) {
      axios.post(`/service-costs/${cost.id}/update`, {
        rate_name: cost.rate_name,
        price_company: cost.price_company,
        price_client: cost.price_client,
        quantity: cost.quantity,
      })
          .then(response => {
            this.showToast('success', 'Sukces', 'Koszt został zaktualizowany.');
            this.editingId = null;
          })
          .catch(error => {
            console.error('Błąd aktualizacji kosztu:', error);
            this.showToast('error', 'Błąd', 'Nie udało się zaktualizować kosztu.');
          });
    },

    updateCurrency() {
      axios.post(`/service/${this.service.id}/update-currency`, {
        currency: this.selectedCurrency
      })
          .then(response => {
            this.showToast('success', 'Sukces', `Waluta została zmieniona na ${this.selectedCurrency}.`);
          })
          .catch(error => {
            this.showToast('error', 'Błąd', 'Nie udało się zaktualizować waluty.');
            console.error(error);
          });
    },

    async deleteServiceCost(id) {
      if (!confirm("Czy na pewno chcesz usunąć ten rekord?")) return;

      try {
        await axios.delete(`/service-costs/${id}`);
        this.serviceCosts = this.serviceCosts.filter(cost => cost.id !== id);
        this.showToast('success', 'Sukces', 'Koszta zostały usunięte.');
      } catch (error) {
        this.showToast('error', 'Błąd', 'Nie udało się usunąć rekordu.');
      }
    },

    resetForm() {
      this.selectedRateId = null;
      this.selectedRate = {};
      this.selectedRateName = "";
      this.selectedPriceCompany = 0;
      this.selectedPriceClient = 0;
      this.quantity = 1;
    },

    async saveServiceCost() {
      if (!this.selectedRateName || !this.quantity) {
        this.showToast('error', 'Błąd', 'Podaj nazwę i ilość!');
        return;
      }

      try {

        await axios.post(route('service-costs.store'), {
          service_id: this.service.id,
          rate_name: this.selectedRateName,
          price_company: this.selectedPriceCompany,
          price_client: this.selectedPriceClient,
          quantity: this.quantity,
        });
        await this.fetchServiceCosts(this.service.id);
        this.resetForm();
        this.showToast('success', 'Sukces', 'Koszta zostały dodane.');

      } catch (error) {
        this.showToast('error', 'Błąd', 'Nie udało się dodać kosztów.');
      }
    },

    async fetchServiceCosts(serviceId) {
      try {
        const response = await axios.get(`/service-costs/${serviceId}`);
        this.serviceCosts = response.data;
      } catch (error) {
        console.error("Błąd pobierania danych:", error);
      }
    },

    submitHideOnList() {
      axios.post(route('service.updateHideOnList', {service: this.service.id}), {
        hide_on_list: this.hideOnListForm.hide_on_list
      })
          .then(() => {
            this.hideOnListServiceHasChanged = false;
            this.showToast('success', 'Sukces', 'Status ukrycia na liście został zaktualizowany.');
          })
          .catch(error => {
            console.error(error);
            this.showToast('error', 'Błąd', 'Nie udało się zapisać zmian.');
          });
    },

    submitArchived() {
      axios.post(route('service.updateArchived', {service: this.service.id}), {
        archived: this.archiveOnListForm.archived
      })
          .then(() => {
            this.archivedHasChanged = false;
            this.showToast('success', 'Sukces', 'Status archiwizacji został zaktualizowany.');
          })
          .catch(error => {
            console.error(error);
            this.showToast('error', 'Błąd', 'Nie udało się zapisać zmian.');
          });
    },
    deleteService(event) {
      const self = this;
      Toast.fire({
        toast: false,
        icon: 'warning',
        title: 'Usuwanie zgłoszenia',
        html: '<strong>Czy na pewno chcesz usunąć to zgłoszenie?</strong><br>Tej operacji nie można cofnąć!',
        showDenyButton: true,
        showConfirmButton: true,
        confirmButtonColor: '#d33',
        confirmButtonText: 'Tak, usuń',
        denyButtonText: 'Anuluj',
        position: 'center',
        showClass: {popup: 'animate__animated animate__fadeInDown'},
        hideClass: {popup: 'animate__animated animate__fadeOutUp'},
      }).then((result) => {
        if (result.isConfirmed) {
          axios.delete(route('service.destroy', this.service.id), {
            headers: {
              'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
            }
          }).then(response => {
            Toast.fire({
              icon: 'success',
              title: 'Zgłoszenie usunięte',
              html: '<strong>Zgłoszenie zostało pomyślnie usunięte.</strong><br>Za chwilę nastąpi przekierowanie...',
              timer: 3000,
              timerProgressBar: true,
            });
            setTimeout(() => {
              self.$inertia.visit(route('service.index'));
            }, 3000);
          }).catch(error => {
            console.error('Błąd usuwania:', error);
            Toast.fire({
              icon: 'error',
              title: 'Błąd usuwania',
              html: '<strong>Nie udało się usunąć zgłoszenia.</strong><br>Spróbuj ponownie później.',
            });
          });
        }
      });
    },
    deleteServiceCost(id) {
      const self = this;

      Toast.fire({
        toast: false,
        icon: "warning",
        title: "Usuwanie kosztu",
        html: "<strong>Czy na pewno chcesz usunąć ten rekord?</strong><br>Tej operacji nie można cofnąć!",
        showDenyButton: true,
        showConfirmButton: true,
        confirmButtonColor: '#ff5733',
        denyButtonColor: '#3498db',
        confirmButtonText: "Tak, usuń",
        denyButtonText: "Anuluj",
        position: "center",
        showClass: {popup: "animate__animated animate__fadeInDown"},
        hideClass: {popup: "animate__animated animate__fadeOutUp"},
      }).then((result) => {
        if (result.isConfirmed) {
          axios.delete(`/service-costs/${id}`)
              .then(() => {
                self.serviceCosts = self.serviceCosts.filter((cost) => cost.id !== id);

                Toast.fire({
                  icon: "success",
                  title: "Koszt usunięty",
                  html: "<strong>Koszt został pomyślnie usunięty.</strong>",
                  timer: 3000,
                  timerProgressBar: true,
                });
              })
              .catch(() => {
                Toast.fire({
                  icon: "error",
                  title: "Błąd usuwania",
                  html: "<strong>Nie udało się usunąć kosztu.</strong> Spróbuj ponownie później.",
                });
              });
        }
      });
    },
	
    showToast(icon, title, message) {
      Toast.fire({
        position: 'top-end',
        toast: true,
        icon: icon,
        title: title,
        html: message,
        showClass: {popup: 'animate__animated animate__fadeInDown'},
        hideClass: {popup: 'animate__animated animate__fadeOutUp'},
        timer: 2500,
        timerProgressBar: true,
        showConfirmButton: false,
        showCloseButton: true
      });
    }
  },
  provide: {
    grid: [Toolbar, ExcelExport]
  },
};

</script>


<style scoped>
.tooltip {
  opacity: 1 !important;
}
</style>
